import { useContext, useEffect, useState, useMemo } from "react";
import { Card, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Button } from "@lynx/ui-components";

import { updateProfileAC } from "../../actions-thunks/actions";
import ChangePasswordBlock from "ui/change-password/ChangePassword";
import { ModalContext } from "ui/ui-kit/modal/ModalContext";
import ConfirmationModal from "ui/components/modals/confirmation/ConfirmationModal";
import useStatistic from "ui/hooks/useStatistic";
import { documentAPI } from "api/document-api";
import { navigationList } from "ui/sidebar-navigation/helpers";

import "./EditProfile.scss";

const EditProfile = () => {
  const { profileData, profileActive } = useSelector((state) => state.profile);
  const { currentAccount } = useSelector((state) => state.accounts);
  const { currentPageTitle } = useSelector((state) => state.utils);

  const { showModal, hideModal } = useContext(ModalContext);

  const [changePasswordBlock, setChangePasswordBlock] = useState(false);

  const dispatch = useDispatch();
  const username = profileData?.username || "";
  const firstname =
    currentAccount?.personal.firstName || profileData?.firstName || "";
  const lastname =
    currentAccount?.personal.lastName || profileData?.lastName || "";

  useStatistic(currentAccount?._id, "Open page Personal information");

  useEffect(() => {
    if (profileData?.changePasswordStatus === "success") {
      dispatch(updateProfileAC({ changePasswordStatus: "" }));
      const closeModal = () => {
        hideModal();
        setChangePasswordBlock(false);
      };
      showModal(
        <ConfirmationModal
          showEditModal
          closeModal={closeModal}
          labels={{
            title: "Password change",
            body: "Password was changed successfully.",
            buttons: { apply: "Ok" },
          }}
        />
      );
    }
  }, [profileData?.changePasswordStatus, dispatch, hideModal, showModal]);

  const checkIfShowDownloadAgreement = useMemo(() => {
    const sidebarNavigation = navigationList.find(
      (item) => item.summary === currentPageTitle
    );
    return (
      sidebarNavigation?.allowDownload && currentAccount?.agreement?.filePath
    );
  }, [currentPageTitle, currentAccount]);

  const findAgreementSign = useMemo(() => {
    return currentAccount?.signs.find(
      (sign) => sign.signID === "useragreement"
    );
  }, [currentAccount]);

  const agreementSignDate = useMemo(() => {
    return findAgreementSign?.signDate ? moment(findAgreementSign?.signDate).format("DD/MM/YYYY") : "";
  }, [findAgreementSign?.signDate]);

  const handleDownload = () => {
    const fileName = `Professional Trader Agreement - ${findAgreementSign?.signVersion} - ${agreementSignDate}.pdf`;
    documentAPI.downloadTradingServiceAgreement(currentAccount._id, fileName);
  };

  if (profileActive)
    return (
      <div className="edit-profile-page-block">
        <Card className="edit-profile-card">
          <div className="form-block">
            <Form className="form-wrapper">
              <div className="d-flex">
                <Form.Group
                  className="form-group-block mb-3"
                  controlId="profile-name"
                >
                  <Form.Label>First name</Form.Label>
                  <Form.Control
                    type="text"
                    name="firstname"
                    readOnly
                    value={firstname}
                    placeholder="Your name"
                  />
                </Form.Group>

                <Form.Group
                  className="form-group-block mb-3"
                  controlId="profile-lastname"
                >
                  <Form.Label>Last name</Form.Label>
                  <Form.Control
                    type="text"
                    name="lastname"
                    readOnly
                    value={lastname}
                    placeholder="Your lastname"
                  />
                </Form.Group>
              </div>
              <Form.Group
                className="form-group-block mb-3"
                controlId="profile-phone"
              >
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="username"
                  readOnly
                  value={username}
                  placeholder="Your email"
                />
              </Form.Group>
              {checkIfShowDownloadAgreement && (
                <Form.Group
                  className="form-group-block mb-3"
                  controlId="profile-agreement"
                >
                <Form.Label>Agreement sign date</Form.Label>
                <div 
                  className="form-control agreement-date-control"
                  style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    cursor: 'pointer'
                  }}
                  onClick={handleDownload}
                >
                  <span>{agreementSignDate}</span>
                  <img
                    src={`${process.env.PUBLIC_URL}/download-gr.svg`}
                    alt="download"
                    style={{ height: '20px' }}
                  />
                </div>
              </Form.Group>
              )}
            </Form>
            {changePasswordBlock ? (
              <ChangePasswordBlock
                setChangePasswordBlock={setChangePasswordBlock}
              />
            ) : (
              <Button
                size="sm"
                buttonStyle="zimtra-secondary"
                buttonClassName="edit-profile-main-button"
                onClick={() => setChangePasswordBlock(!changePasswordBlock)}
                label="Change password"
              />
            )}
          </div>
        </Card>
      </div>
    );
  return null;
};

export default EditProfile;
